const rail = {
  rails: "导轨", // translated
  senior: "高级的", // translated
  seniors: "老年人", // translated
  youths: "青少年组", // translated
  yearOld: "岁", // translated
  yearsOld: "岁", // translated
};

export default rail;
